import React from 'react';
import { Loader, Icon, Table, Button, Header, Label } from 'semantic-ui-react';
import moment from 'moment';
import FileSaver from 'file-saver';
import { getIdsAndTime, getDuration, filterDigitalIndicators } from '../helper/helper';
// import { digitalInputValueFormat } from '../../../helper/digital-input-value-format';
import { REGULAR_PATH } from '../../../../env';
import SelectAssetInReport from '../SelectAssetInReport';
import { alertMessage } from '../../../helper/alert-message';
import { reportView, reportDownloadExcel } from '../helper/dataService';

import reportsEnv from '../reportsEnv';
import { getData, handleMultipleRequest } from '../../../helper/dataService';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  Area,
  Tooltip as TooltipChart,
} from 'recharts';

const { durationLimit, assetLimit } = reportsEnv.digitalInput;

class DigitalIndicator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      pdfDisableBtn: false,
      excelDisableBtn: false,
      assetsList: [],
      selectedAssets: [],
      data: [],
      startTime: moment().startOf('day'),
      endTime: moment().endOf('day'),
      digitalInput1: false,
      digitalInput2: false,
      digitalInput3: false,
      assetsWithDigitalInput: [],
      graphData: [],
    };
  }

  componentDidMount() {
    const {
      selectedAssets = [],
      startTime,
      endTime,
    } = JSON.parse(window.localStorage.getItem('reports_state'));

    this.setState({
      selectedAssets,
      startTime: moment(startTime),
      endTime: moment(endTime),
    });
  }

  getBack = () => {
    this.setState({
      data: [],
    });
  };

  downloadReport = () => {
    this.setState({
      active: true,
      pdfDisableBtn: false,
      excelDisableBtn: false,
      assetsWithDigitalInput: [],
    });
    const { ids, startTime, endTime } = getIdsAndTime(this.state);

    let promises = [];

    for (let i = 0; i < ids.length; i++) {
      let id = ids[i];
      let url = `${REGULAR_PATH}/assets/${id}/last_data?access_token=`;

      promises.push(getData(url));
    }

    let lastDataResponse = handleMultipleRequest(promises);

    Promise.all([
      lastDataResponse,
      reportView(reportsEnv.digitalInput, {
        asset_ids: ids,
        from: startTime,
        to: endTime,
      }),
    ])
      .then(([results, response]) => {
        const assetsMap = {};
        (results || []).forEach((res) => {
          if (res && res.data) {
            assetsMap[res.data.name] = res.data;
          }
        });

        const { data } = response;
        const filteredData = filterDigitalIndicators(data, assetsMap);

        this.setState({ assetDataFetched: false });

        if (filteredData.length === 0) {
          alertMessage('No data found for enabled digital indicator sensors');
        }

        this.setState({
          data: filteredData,
          active: false,
        });
      })
      .catch((error) => {
        this.setState({ active: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  handleDownloadExcelBtn = () => {
    this.setState({ excelDisableBtn: true });

    const { ids, startTime, endTime } = getIdsAndTime(this.state);
    reportDownloadExcel(reportsEnv.digitalInput, {
      asset_ids: ids,
      from: startTime,
      to: endTime,
    })
      .then((response) => {
        FileSaver.saveAs(
          response.data,
          `Finder_Digital_Indicator_Report_${moment().format(
            'DD-MMMM-YYYY_hh:mm A',
          )}.xlsx`,
        );
        this.setState({ excelDisableBtn: false });
      })
      .catch((error) => {
        this.setState({ excelDisableBtn: false });
        alertMessage(`Sorry! Something went wrong`);
      });
  };

  render() {
    const {
      selectedAssets,
      data,
      active,
      pdfDisableBtn,
      excelDisableBtn,
      startTime,
      endTime,
    } = this.state;

    const duration = getDuration(endTime, startTime);
    const assetsQuantity = selectedAssets.length;

    const isDurationLimitCross = duration > durationLimit;
    const isAssetLimitCross = assetsQuantity > assetLimit;

    if (isDurationLimitCross) {
      alertMessage(
        `You can't select this report more than ${durationLimit} days.`,
      );
    } else if (isAssetLimitCross) {
      alertMessage(
        `You can't select this report more than ${assetLimit} assets.`,
      );
    }

    const title = `Digital Indicator [${durationLimit} days][${assetLimit} asset]`;
    const isValidDuration =
      duration > 0 && endTime.isSameOrAfter(startTime) && !isDurationLimitCross;
    const isValidAsset = assetsQuantity > 0 && !isAssetLimitCross;

    return (
      <div>
        {!active && data.length <= 0 && (
          <div className=' center-report'>
            <Header as='h2'>{title}</Header>

            <div style={{ margin: '20px 0' }}>
              <Label.Group size='large'>
                <Label>
                  <Icon name='car' />
                  {assetsQuantity} assets
                </Label>
                <Label>
                  <Icon name='calendar' />
                  {duration} days
                </Label>
                <Label>
                  <Icon name='play' />
                  {moment(startTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
                <Label>
                  <Icon name='stop' />
                  {moment(endTime).format('dddd, MMMM Do, YYYY, hh:mm:ss A')}
                </Label>
              </Label.Group>
            </div>

            {isValidDuration && isValidAsset && (
              <Button.Group>
                <Button
                  color='black'
                  style={{ width: '200px', fontSize: '16px' }}
                  onClick={this.downloadReport}
                  icon='eye'
                  content='VIEW HERE'
                  disabled={pdfDisableBtn || excelDisableBtn}
                />

                <Button
                  color='teal'
                  style={{ width: '200px', fontSize: '16px' }}
                  icon='file excel outline'
                  content='Download Excel'
                  onClick={this.handleDownloadExcelBtn}
                  disabled={excelDisableBtn || pdfDisableBtn}
                  loading={excelDisableBtn}
                />
              </Button.Group>
            )}
          </div>
        )}

        {!active && data.length > 0 ? (
          <div style={{ margin: '2%' }}>
            <div className='left-right'>
              <div>
                <Header as='h2'>Digital Indicator</Header>
                <p>
                  Generated on: {moment().format('MMMM Do, YYYY, hh:mm:ss A')}
                </p>
              </div>
              <Button primary onClick={this.getBack}>
                Back
              </Button>
            </div>

            <br />

            {data.map((item, i) => (
              <div
                key={`${item.digital_indicator_name}-${i}`}
                id={item.digital_indicator_name}
              >
                <div className='ui stackable grid'>
                  <div className='eight wide column' style={{ paddingLeft: 0 }}>
                    <div className='ui card fluid'>
                      <div className='content'>
                        <div className='header'>
                          {item.data.asset_detail.name}
                        </div>

                        <div className='description'>
                          <div>
                            <p>
                              <i className='arrow right icon' /> From:
                              {moment(startTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                            <p>
                              <i className='arrow right icon' /> Till:{' '}
                              {moment(endTime).format(
                                'dddd, MMMM Do, YYYY, hh:mm:ss A',
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className='eight wide column'
                    style={{ paddingRight: 0 }}
                  >
                    <div className='ui card fluid'>
                      <div className='content'>
                        <h2 className='ui center aligned icon header'>
                          <i className='circular car icon' />
                        </h2>
                        <div>
                          <p
                            style={{
                              fontSize: 15,
                              fontWeight: 600,
                            }}
                          >
                            <span style={{ marginRight: 7 }}> Name:</span>
                            {item.digital_indicator_name}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontSize: 15,
                              marginTop: 5,
                              fontWeight: 600,
                            }}
                          >
                            <span style={{ marginRight: 7 }}>Total On:</span>
                            {item.data.asset_detail.total_engine_on}
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontSize: 15,
                              marginTop: 5,
                              fontWeight: 600,
                            }}
                          >
                            <span style={{ marginRight: 7 }}>
                              Total On Time:
                            </span>
                            {item.data.asset_detail.total_ignition_on_time}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {item.data.ignition_status.length ? (
                  <>
                    <ResponsiveContainer height={200} width='100%'>
                      <ComposedChart
                        data={item.data.ignition_status.map((data) => ({
                          stoppedAt: data.ignition_stopped_at
                            ? moment(data.ignition_stopped_at.$date).format(
                                'DD MMM',
                              )
                            : 'No date',
                          awake: Math.ceil(data.in_seconds / 60),
                        }))}
                      >
                        <CartesianGrid stroke='#ced4da' />
                        <XAxis dataKey='stoppedAt' />
                        <YAxis />
                        <TooltipChart />
                        <Legend />
                        <Area
                          type='monotone'
                          dataKey='awake'
                          name='Awake Time (Minutes)'
                          stroke='#12b886'
                          fill='#12b886'
                          dot={false}
                          isAnimationActive={true}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  </>
                ) : null}

                <div>
                  <Table celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>No</Table.HeaderCell>
                        <Table.HeaderCell>Start</Table.HeaderCell>
                        <Table.HeaderCell>End</Table.HeaderCell>
                        <Table.HeaderCell>Time Duration</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                      {item.data.ignition_status.map((item, id) => {
                        return (
                          <Table.Row key={id}>
                            <Table.Cell>{id + 1}</Table.Cell>
                            <Table.Cell>
                              {item.ignition_starts_at
                                ? moment(item.ignition_starts_at.$date).format(
                                    'dddd, MMMM Do, YYYY, hh:mm:ss A',
                                  )
                                : ''}
                            </Table.Cell>
                            <Table.Cell>
                              {item.ignition_stopped_at
                                ? moment(item.ignition_stopped_at.$date).format(
                                    'dddd, MMMM Do, YYYY, hh:mm:ss A',
                                  )
                                : ''}
                            </Table.Cell>
                            <Table.Cell>{item.ignition_awake}</Table.Cell>
                          </Table.Row>
                        );
                      })}
                    </Table.Body>
                  </Table>
                </div>

                <br />
              </div>
            ))}
            {data.length > 1 ? (
              <SelectAssetInReport
                assetList={data.map((d) => ({
                  asset_detail: {
                    name: d.digital_indicator_name,
                  },
                }))}
              />
            ) : null}
          </div>
        ) : (
          <Loader active={active} inline='centered'>
            Generating...
          </Loader>
        )}
      </div>
    );
  }
}

export default DigitalIndicator;
